import { err, ok, Result } from "neverthrow"
import { CloudToDeviceOfflineTableDrugSearchWordBody } from "../redux/syncthunk/ZCloudToDevice"
import { bulkInsert } from "./bulkInsert"
import { sqlQuery, sqlRun } from "./ldb"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { selectAllText } from "./LdbBrowser"

export const selectDrugSearchWordIsPresent = async (word: string): Promise<Result<boolean, FusionError>> => {
	let r = await sqlQuery<{count: number}>(
		`
			select count(*) as count
			  from drugSearchWord
			 where word = ?
		`,
		[
			word,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectDrugSearchWordIsPresent', r.error))
	}
	return ok(r.value[0].count > 0)
}

export const selectAllDrugSearchWords = async (): Promise<Result<string[], FusionError>> => {
	let r = await sqlQuery<{word: string}>(`
		select word from drugSearchWord
	`)
	if(r.isErr()) {
		return err(serializeFusionError('selectAllDrugSearchWords', r.error))
	}
	return ok(r.value.map(row => row.word))
}

export const selectAllDrugSearchWordText = async (): Promise<string> => {
	return selectAllText('drugSearchWord', ['word'])
}

export const ldbDrugSearchWordBulkInsert = async (body: CloudToDeviceOfflineTableDrugSearchWordBody): Promise<Result<void, FusionError>> => {
	let r = await sqlRun('delete from drugSearchWord')
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugSearchWordBulkInsert', r.error))
	}
	const uniqueDrugNames = Array.from(new Set(body.Words))
	r = await bulkInsert('drugSearchWord', uniqueDrugNames, 1)
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugSearchWordBulkInsert', r.error))
	}
	// console.debug(`Inserted ${uniqueDrugNames.length} drug names into the database.`)
	return ok()
}
